import React, { useEffect, useRef, useState } from "react";
import { format } from "date-fns";
import {
  DateInput,
  SelectInput,
  TextInput,
} from "../components/common/ui/Inputs";
import Button from "../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { masterActions } from "../_store";
import generateXlsx from "../components/common/export/generateXlsx";
import { textSearchAction } from "../_store/textSearch.slice";
import CustomLoader from "../components/common/ui/Loader";
import { fDate, getCurrentDate, getPastDate } from "../utils/formatTime";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import textSearchSchema from "../validation/textSearchSchema";

function TextSearch() {
  const commonFacilityCode = useSelector(
    (state) => state.auth.commonFacilityCode
  );
  const {
    LoadTextSearchListFullList: exceldata,
    loading,
    textSearchdata,
  } = useSelector((state) => state.textSearch || {});
  //DropdownValues
  const { matchTypeOptions, dateRangeOptions } = useSelector(
    (x) => x.dropdownOptions
  );
  const prevFacilityCodeRef = useRef(commonFacilityCode);
  const [textSearch, setTextSearch] = useState(textSearchdata);
  const [showSearchFields, setShowSearchFields] = useState(true);
  const [exportDataResponseText, setExportDataResponseText] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    if (prevFacilityCodeRef.current !== commonFacilityCode) {
      handleReset();
    }
  }, [commonFacilityCode]);

  useEffect(() => {
    setTextSearch(textSearchdata);
    if (textSearchdata?.dateRangeType == 5) {
      setShowDatepicker(true);
    }
    else {
      setShowDatepicker(false);
    }
  }, [textSearchdata]);

  useEffect(() => {
    dispatch(
      masterActions.LoadFacilityDropDown({
        facilityID: 0,
        activeStatus: 1,
      })
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      textSearchAction.settextSearch({
        ...textSearchdata,
        facilityID: commonFacilityCode,
      })
    );
  }, [commonFacilityCode]);

  /// State to manage selected dropdown value
  // const [selectedOption, setSelectedOption] = useState("");
  // State to manage visibility of the datepicker
  const [showDatepicker, setShowDatepicker] = useState(false);



  //For Excel and PDF

  const [errorMessage, setErrorMessage] = useState({});

  const handleInputChange = (name, valueOrEvent) => {
    let value;

    if (valueOrEvent && valueOrEvent.target) {
      value = valueOrEvent.target.value;
    } else if (
      typeof valueOrEvent === "object" &&
      valueOrEvent?.value !== undefined
    ) {
      value = valueOrEvent.value;
    } else {
      value = valueOrEvent;
    }

    if (name === "matchType") {
      setTextSearch((prev) => ({
        ...prev,
        [name]: value ?? 2,
      }));
      return;
    }

    // if (name === "dateRangeType") {
    //   setTextSearch((prev) => ({
    //     ...prev,
    //     [name]: value ?? 1,
    //   }));
    // }

    // **Handle Date Range Selection (Ensures From & To Date fields appear only when dateRangeType is 5)**
    if (name === "dateRangeType") {
      let currentDate = getCurrentDate();
      let backDate = "";

      if (value === 5) {
        setShowDatepicker(true);
        backDate = "";
        currentDate = "";
      } else {
        setShowDatepicker(false);
        switch (value) {
          case 1:
            backDate = getPastDate(1);
            break;
          case 2:
            backDate = getPastDate(3);
            break;
          case 3:
            backDate = getPastDate(6);
            break;
          case 4:
            backDate = getPastDate(12);
            break;
          default:
            backDate = "";
            currentDate = "";
            break;
        }
      }

      setTextSearch((prev) => ({
        ...prev,
        fromDate: backDate,
        toDate: currentDate,
        dateRangeType: value ?? 1,
      }));

      setErrorMessage((prev) => ({
        ...prev,
        fromDate: "",
        toDate: "",
      }));
      return;
    }

    // **Instant Validation for `fromDate` & `toDate` Without onBlur**
    if (name === "fromDate" || name === "toDate") {
      if (!value) {
        setTextSearch((prev) => ({
          ...prev,
          [name]: "",
        }));

        setErrorMessage((prev) => ({
          ...prev,
          [name]: `Please enter ${name === "fromDate" ? "From Date" : "To Date"
            }.`,
        }));
        return;
      }

      const formattedDate = fDate(value);
      // **Instant Validation for selected toDate after selecting fomDate` Without onBlur**
      const newDate = new Date(value);

      const otherDateName = name === "fromDate" ? "toDate" : "fromDate";
      const otherDateValue = textSearch[otherDateName];

      if (otherDateValue) {
        const otherDate = new Date(otherDateValue);

        if (name === "fromDate" && newDate > otherDate) {
          setErrorMessage((prev) => ({
            ...prev,
            [name]: "",
          }));
          return;
        }

        if (name === "toDate" && newDate < otherDate) {
          setErrorMessage((prev) => ({
            ...prev,
            [name]: "",
          }));
          return;
        }
      }

      setTextSearch((prev) => ({
        ...prev,
        [name]: formattedDate,
      }));

      // dispatch(
      //   textSearchAction.settextSearch({
      //     ...textSearchdata,
      //     [name]: formattedDate,
      //   })
      // );

      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));
      return;
    }

    // **Instant Validation for `msgKeyword`**
    if (name === "msgKeyword") {
      value = value.replace(/[^a-zA-Z0-9\s]/g, "");

      if (!value.trim()) {
        setErrorMessage((prev) => ({
          ...prev,
          msgKeyword: "Please enter Search Text.",
        }));
      } else if (value.length < 2) {
        setErrorMessage((prev) => ({
          ...prev,
          msgKeyword: "Minimum 2 characters required.",
        }));
      } else {
        setErrorMessage((prev) => ({
          ...prev,
          msgKeyword: "",
        }));
      }
    }

    setTextSearch((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDateEnterKey = (event, name) => {
    let updatedData = { ...textSearch };
    if (event.key === "Enter" && updatedData[name] === "") {
      const currentDate = new Date();

      // Set today's date using the same logic as your handleDateChange
      if (
        (name === "fromDate" &&
          new Date(updatedData?.toDate).toDateString() ===
          currentDate.toDateString()) ||
        (name === "toDate" &&
          new Date(updatedData?.fromDate).toDateString() ===
          currentDate.toDateString()) ||
        (updatedData?.toDate === "" && updatedData?.fromDate === "") ||
        updatedData?.fromDate
      ) {
        // If both fromDate and toDate are empty, set fromDate to current date
        handleInputChange(name, currentDate);
      }
      // If toDate is earlier than the current date, clear fromDate
      else if (new Date(updatedData?.toDate) < currentDate) {
        handleInputChange(name, "");
      }
    }

    const regex = /^[0-9/]$/; // Allow numbers and "/"

    if (
      !regex.test(event.key) &&
      event.key !== "Backspace" &&
      event.key !== "Delete" &&
      !(event.ctrlKey && event.key === "v")
    ) {
      event.preventDefault();
    }

    // Auto-insert '/' when typing
    const input = event.target.value;

    if (event.key !== "Backspace" && event.key !== "Delete") {
      if (input?.length === 2 || input?.length === 5) {
        event.target.value = input + "/";
      }
    }
  };

  const getReportData = async (e) => {
    e.preventDefault();
    const textState = {
      ...textSearch,
      exportExcel: true,
      facilityID: commonFacilityCode,
    };
    setErrorMessage({});
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }
    // Validate input fields
    const { error } = textSearchSchema(textState);
    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        const inputElement = document.querySelector(
          `input[name="${path}"], textarea[name="${path}"], DatePicker[name="${path}"]`
        );
        if (inputElement) {
          inputElement.classList.add("input-error");
        }
      });
      return;
    }
    try {
      await dispatch(textSearchAction.LoadTextSearchList(textState))
        .then((result) => {
          if (result?.payload?.length === 0) {
            setExportDataResponseText(
              `<label class="fs-5 fw-bold text-danger">No Data Available</label>`
            );
            return;
          } else {
            setExportDataResponseText(
              `<label class="fs-5 fw-bold" style="color: rgb(0, 151, 89);">Data generated successfully. Click download button to export Excel.</label>`
            );
          }
        })
        .catch((err) => {
          showToastNotification(err?.message, "error");
        });
    } catch (error) {
      showToastNotification("Failed to get data", "error");
    }
  };

  const handleDownload = (e) => {
    if (exceldata?.length === 0) return;
    const title = "TextSearch";
    const generateExcelColumns = [
      "FacilityCode",
      "PublicUserName",
      "PublicUserFullName",
      "InmateResidentId",
      "InmateFullName",
      "Sender",
      "Receiver",
      "MessageSubject",
      "MessageBody",
      "MessageSentDate",
      "MessageReceiveDate",
    ];

    const formatDateTime = (dateString) => {
      if (!dateString) return "";
      const date = new Date(dateString);
      if (isNaN(date)) return dateString;

      return date.toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    };

    const new_TextSearchList =
      exceldata?.map((obj) => ({
        FacilityCode: obj.FacilityCode,
        PublicUserName: obj.PublicUserName,
        PublicUserFullName: obj.PublicUserFullName,
        InmateResidentId: obj.InmateResidentId,
        InmateFullName: obj.InmateFullName,
        Sender: obj.Sender,
        Receiver: obj.Receiver,
        MessageSubject: obj.MessageSubject,
        MessageBody: obj.MessageBody,
        MessageSentDate: formatDateTime(obj.MessageSentDate),
        MessageReceiveDate: formatDateTime(obj.MessageReceiveDate),
      })) || [];
    try {
      generateXlsx(new_TextSearchList, generateExcelColumns, title);
      // showToastNotification("Match found, Downloaded successfully", "success");
      setExportDataResponseText("");
      dispatch(textSearchAction.cleartextSearchData());
    } catch (error) {
      showToastNotification("Error generating Excel file : ", "error");
    }
    dispatch(textSearchAction.cleartextSearchData());
  };

  const handleClickExcel = async (e) => {
    e.preventDefault();

    const textState = {
      ...textSearch,
      exportExcel: true,
      facilityID: commonFacilityCode,
    };

    setErrorMessage({});

    // if (document?.getElementsByClassName("input-error").length !== 0) {
    //   document
    //     .querySelectorAll(".input-error")
    //     .forEach((el) => el.classList.remove("input-error"));
    // }
    if (document?.getElementsByClassName("input-error").length !== 0) {
      document.querySelector(".input-error").classList.remove("input-error");
    }
    // Validate input fields
    const { error } = textSearchSchema(textState);
    if (error?.details) {
      error?.details?.forEach((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path.toString()]: e.message,
        }));

        const inputElement = document.querySelector(
          `input[name="${path}"], textarea[name="${path}"], DatePicker[name="${path}"]`
        );
        if (inputElement) {
          inputElement.classList.add("input-error");
        }
      });
      return;
    }

    try {
      const res = await dispatch(
        textSearchAction.LoadTextSearchList(textState)
      );
      const exceldata = res.payload;

      if (exceldata.length === 0) {
        showToastNotification("No data found", "error");
        dispatch(textSearchAction.UpdateExcelResponse());
        return;
      }

      const title = "TextSearch";
      const generateExcelColumns = [
        "FacilityCode",
        "PublicUserName",
        "PublicUserFullName",
        "InmateResidentId",
        "InmateFullName",
        "Sender",
        "Receiver",
        "MessageSubject",
        "MessageBody",
        "MessageSentDate",
        "MessageReceiveDate",
      ];

      const formatDateTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date)) return dateString;

        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        });
      };

      const new_TextSearchList =
        exceldata?.map((obj) => ({
          FacilityCode: obj.FacilityCode,
          PublicUserName: obj.PublicUserName,
          PublicUserFullName: obj.PublicUserFullName,
          InmateResidentId: obj.InmateResidentId,
          InmateFullName: obj.InmateFullName,
          Sender: obj.Sender,
          Receiver: obj.Receiver,
          MessageSubject: obj.MessageSubject,
          MessageBody: obj.MessageBody,
          MessageSentDate: formatDateTime(obj.MessageSentDate),
          MessageReceiveDate: formatDateTime(obj.MessageReceiveDate),
        })) || [];

      try {
        generateXlsx(new_TextSearchList, generateExcelColumns, title);
        showToastNotification(
          "Match found, Downloaded successfully",
          "success"
        );
        dispatch(textSearchAction.cleartextSearchData());
      } catch (error) {
        console.error("Error generating Excel file:", error);
      }
      dispatch(textSearchAction.cleartextSearchData());
    } catch (error) {
      console.error("Error generating Excel file:", error);
      showToastNotification("Error generating report", "error");
    }
  };

  // Reset the Serach box
  const handleReset = () => {
    setExportDataResponseText("");
    dispatch(textSearchAction.UpdateExcelResponse());
    setTextSearch({
      facilityID: commonFacilityCode,
      msgKeyword: "",
      matchType: 2,
      fromDate: getPastDate(1),
      toDate: getCurrentDate(),
      sortBy: "",
      dateRangeType: 1,
    });
    setShowDatepicker(false);
    setErrorMessage({});

    document.querySelectorAll(".input-error, .is-invalid").forEach((el) => {
      el.classList.remove("input-error", "is-invalid");
    });
  };

  //   const handleBlur = (field) => {
  //     setTextSearch((prev) => {
  //         const dateValue = prev[field];
  //         const isValidDate = dateValue && !isNaN(new Date(dateValue).getTime()) && new Date(dateValue).getFullYear() >= 1990;

  //         if (!isValidDate) {
  //             return { ...prev, [field]: "" };
  //         }

  //         if (field === "fromDate" && prev.toDate && new Date(dateValue) > new Date(prev.toDate)) {
  //             return { ...prev, fromDate: "" };
  //         }

  //         if (field === "toDate") {
  //             const oneMonthAgo = new Date();
  //             oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  //             if ((prev.fromDate && new Date(dateValue) < new Date(prev.fromDate)) || new Date(dateValue) > oneMonthAgo) {
  //                 return { ...prev, toDate: "" };
  //             }
  //         }

  //         return prev;
  //     });
  // };

  const handleBlur = async (e) => {
    let { name, value } = e.target;

    if (name === "msgKeyword") {
      if (!value.trim()) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Please enter Search Text",
        }));
        return;
      } else if (value.trim().length < 2) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "Minimum 2 characters required.",
        }));
        return;
      } else {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    if (name === "fromDate" || name === "toDate") {
      value = value ? format(new Date(value), "MM/dd/yyyy") : "";
    }

    if (name === "fromDate" || name === "toDate") {
      if (textSearch.dateRangeType !== 5) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: "",
        }));
        return;
      }

      if (!value) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: `Please enter ${name === "fromDate" ? "From Date" : "To Date"
            }.`,
        }));
        return;
      }
    }

    try {
      setErrorMessage((prev) => ({
        ...prev,
        [name]: "",
      }));

      await textSearchSchema.validateAsync(
        { [name]: value },
        { abortEarly: false }
      );
    } catch (error) {
      const fieldError = error?.details?.find((err) => err.path.includes(name));
      if (fieldError) {
        setErrorMessage((prev) => ({
          ...prev,
          [name]: fieldError.message,
        }));
      }
    }
  };

  if (loading) {
    return <CustomLoader />;
  }

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form>
        {/* First Row: Search Text, Match Type, Date Range */}
        <div className="row mb-3">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="msgKeyword"
                id="msgKeyword"
                label="Search Text"
                value={textSearch?.msgKeyword}
                handleChange={(e) => handleInputChange("msgKeyword", e)}
                placeholder="Enter Text"
                required={true}
                autoComplete="off"
                maxLength={25}
                errorMessage={errorMessage}
                handleBlur={handleBlur}
                disabled={exceldata?.length > 0}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Match Type */}
              <SelectInput
                name="matchType"
                options={matchTypeOptions}
                value={textSearch?.matchType}
                handleChange={(selectedOption) =>
                  handleInputChange("matchType", selectedOption)
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isLoading={false}
                isClearable={textSearch?.matchType !== 2}
                placeholder="Select"
                label="Match Type"
                isDisabled={exceldata?.length > 0}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Date Range */}
              <SelectInput
                name="dateRangeType"
                options={dateRangeOptions}
                value={textSearch?.dateRangeType}
                handleChange={(selectedOption) =>
                  handleInputChange("dateRangeType", selectedOption)
                }
                isMulti={false}
                closeMenuOnSelect={true}
                isLoading={false}
                isClearable={textSearch?.dateRangeType !== 1}
                placeholder="Select"
                label="Date Range"
                isDisabled={exceldata?.length > 0}
              />
            </div>
          </div>
        </div>
        {/* Second Row: Search Text, Match Type, Date Range */}
        {showDatepicker && (
          <div className="row mb-3">
            <div className="col-sm-6 col-md-6 col-lg-4">
              <div className="form-floating mb-3">
                <DateInput
                  label="From Date"
                  name="fromDate"
                  value={textSearch?.fromDate}
                  required={true}
                  // maxDate={
                  //   textSearch?.DobEndDate ? textSearch?.DobEndDate : new Date()
                  // }
                  maxDate={
                    textSearch?.toDate
                      ? new Date(textSearch.toDate)
                      : textSearch?.DobEndDate
                        ? new Date(textSearch.DobEndDate)
                        : new Date()
                  }
                  handleChange={(date) => handleInputChange("fromDate", date)}
                  yearDropDown={true}
                  isClearable={textSearch?.fromDate}
                  preventClear={false}
                  minDate={new Date(1900, 0, 1)}
                  handleBlur={(e) => handleBlur(e, "fromDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "fromDate")}
                  errorMessage={errorMessage}
                  disabled={exceldata?.length > 0}
                />
              </div>
            </div>

            <div className="col-sm-6 col-md-6 col-lg-4">
              <div className="form-floating mb-3">
                <DateInput
                  label="To Date"
                  name="toDate"
                  value={textSearch?.toDate}
                  disabled={exceldata?.length > 0}
                  required={true}
                  minDate={
                    textSearch?.fromDate ? new Date(textSearch?.fromDate) : ""
                  }
                  maxDate={new Date()}
                  handleChange={(date) => handleInputChange("toDate", date)}
                  yearDropDown={true}
                  isClearable={textSearch?.toDate}
                  preventClear={false}
                  handleBlur={(e) => handleBlur(e, "toDate")}
                  handleKeyDown={(e) => handleDateEnterKey(e, "toDate")}
                  errorMessage={errorMessage}
                />
              </div>
            </div>
          </div>
        )}

        <div className="fs-5">
          <span>
            Note : Enter the text to be searched. Text can either be a single
            word or a combination of 3 words separated by spaces.Text length can
            be between 2 and 25 characters.
          </span>
        </div>
        <div
          className="mt-3"
          dangerouslySetInnerHTML={{ __html: exportDataResponseText }}
        ></div>
        {/* Buttons */}
        <div className="mt-3 flex-wrap d-flex flex-wrap justify-content-center gap-3">
          {exceldata?.length === 0 && (
            <Button
              // variant="danger"
              className="me-2"
              label="GENERATE REPORT"
              type="submit"
              status="primary"
              disabled={false}
              onClick={(e) => getReportData(e)}
              // onClick={(e) => handleClickExcel(e)}
              icon={"fas fa-file-contract"}
            //icon={"search"}
            />
          )}

          {exceldata?.length > 0 && (
            <div>
              <Button
                className="me-2"
                label="Download"
                icon="fa-solid fa-download"
                type="button"
                status="success"
                disabled={false}
                onClick={(e) => handleDownload(e)}
              />
            </div>
          )}
          <Button
            variant="danger"
            className="me-2"
            onClick={handleReset}
            label="RESET"
            type="button"
            status="secondary"
            disabled={false}
            icon="fa-solid fa-rotate-right"
          />
        </div>
      </form>
    );
  };

  return (
    <>
      <div className="TextSearch">
        {commonFacilityCode ? (
          <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
            <div className="card shadow-sm b-r-all  p-4 border border-dark-grey mt-3 w-100">
              {/* <h2 className=" mb-4 text-color">TEXT SEARCH</h2> */}
              <div className=" d-block d-md-none">
                <div
                  className=" d-flex align-items-center justify-content-between"
                  style={{ background: "transparent", cursor: "pointer" }}
                  onClick={toggleInformation}
                >
                  <h2 className="form_title_uppercase text-color">
                    TEXT SEARCH
                  </h2>
                  <i
                    id="itagInformation"
                    className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                      }`}
                    style={{ fontSize: "20px" }}
                  ></i>
                </div>
              </div>
              {/* Mobile only (Below md breakpoint) */}
              <div className="d-block d-md-none mt-2">
                {showSearchFields && renderSearch()}
              </div>

              {/* Web only (Desktop and above) */}
              <div className="mb-3 d-none d-md-block">
                <h2 className="form_title_uppercase text-color">TEXT SEARCH</h2>
              </div>
              {/* Web only (Desktop and above) */}
              <div className="d-none d-md-block">{renderSearch()}</div>
            </div>
          </div>
        ) : (
          <h4 className="facility-card">
            Select a Facility Code from the list
          </h4>
        )}
      </div>
    </>
  );
}

export default React.memo(TextSearch);
